var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnapprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FEE4E2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_13921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 13.333V15.9997M15.9999 18.6663H16.0066M22.6666 15.9997C22.6666 19.6816 19.6818 22.6663 15.9999 22.6663C12.318 22.6663 9.33325 19.6816 9.33325 15.9997C9.33325 12.3178 12.318 9.33301 15.9999 9.33301C19.6818 9.33301 22.6666 12.3178 22.6666 15.9997Z",
    stroke: "#D92D20",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_13921"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnapprove);
export default __webpack_public_path__ + "static/media/icon-unapprove.653fce79816c35198afd3373b6b6cc8c.svg";
export { ForwardRef as ReactComponent };